<template>
  <div class="mt-3 pa-2 rounded elevation-0 bordered bg-grey_3">
    <div class="text-h6 mb-2">Etat de l'inscription</div>
    <div v-if="item.supprime == '1'">
      <v-chip variant="elevated" density="compact" elevation="0"  color="red-darken-4" prepend-icon="mdi-cancel">
        Inscription supprimée </v-chip>
    </div>
    <div v-if="item.transfere == '1'">
      <v-chip variant="elevated" density="compact" elevation="0" color="red-darken-4"
        prepend-icon="mdi-swap-horizontal"> Inscription transférée
      </v-chip>
    </div>
    <div v-if="item.from_transfert == '1'">
      <v-chip variant="elevated" density="compact" elevation="0" color="red-darken-4"
        prepend-icon="mdi-swap-horizontal"> Provient d'un transfert
      </v-chip>
    </div>
    <div v-if="item.supprime == '0' && item.transfere == '0'" class="d-flex align-center sm-gap flex-wrap mt-2">
      <v-chip variant="elevated" density="compact" elevation="0"
        :color="item.affiche == '1' ? 'green-darken-4' : 'red-darken-4'"> <v-icon
          :icon="item.affiche == '1' ? 'mdi-eye' : 'mdi-eye-off'" class="mr-2"></v-icon> Affichée </v-chip>
      <v-chip variant="elevated" density="compact" elevation="0"
        :color="item.paye == '1' ? 'green-darken-4' : 'red-darken-4'"> <v-icon icon="mdi-currency-eur"
          class="mr-2"></v-icon> Payée </v-chip>
      <v-chip variant="elevated" density="compact" elevation="0"
        :color="item.document_recu == '1' ? 'green-darken-4' : 'red-darken-4'"> <v-icon icon="mdi-file-edit-outline"
          class="mr-2"></v-icon> Document reçu </v-chip>
      <v-chip variant="elevated" density="compact" elevation="0"
        :color="item.document_valide == '1' ? 'green-darken-4' : 'red-darken-4'"> <v-icon icon="mdi-file-check-outline"
          class="mr-2"></v-icon> Document validé </v-chip>
      <v-chip variant="elevated" density="compact" elevation="0"
        :color="item.valide == '1' ? 'green-darken-4' : 'red-darken-4'"> <v-icon icon="mdi-check-bold"
          class="mr-2"></v-icon> Validée </v-chip>
    </div>
    <v-divider style="margin: 10px 0 !important"></v-divider>
    <div class="text-h6 mb-2">Remboursements</div>
    <div v-if="item.refunds.length == 0">Aucun remboursement effectué pour cette inscription</div>
    <div v-else>
      <div v-for="refund in item.refunds" :key="refund.id">
        <div class="d-flex align-center sm-gap bordered mb-1 bg-white pa-2">
          <v-icon icon="mdi-currency-eur" color="primary-dark"></v-icon>
          <div>
            <div class="font-weight-bold">Remboursement de {{ refund.amount_refunded }}€</div>
            <div class="text-body-2">
              <span v-if="refund.action == 'refund_and_keep'">L'inscription est conservée</span>
              <span v-if="refund.action == 'refund_and_delete'">L'inscription est supprimée</span>
              <span v-if="refund.action == 'refund_with_gia'">Utilisation de la GIA</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
};
</script>

<style lang="scss" scoped></style>